import Inertia from 'inertia-vue';
import Vue from 'vue';
import { dateFilter } from 'vue-date-fns';
import store from './store';
import '../css/app.css';
import '../sass/app.scss';
import VueTimeago from 'vue-timeago';
import VueDateFns from 'vue-date-fns';
import axios from './axios';
import VueAxios from 'vue-axios';
import { Network } from 'vue2vis';
import 'vue2vis/dist/vue2vis.css';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

/**
 * Inertia
 */
Vue.mixin({ methods: { route: (...args) => window.route(...args).url() } });
Vue.use(Inertia);

/**
 * date-fns format directive
 */
Vue.filter('date', dateFilter);
Vue.use(VueDateFns);

/**
 * Timeago component
 */
Vue.use(VueTimeago, {
  locale: 'es',
  locales: {
    es: require('date-fns/locale/es'),
  },
});

/**
 * Axios
 */

Vue.use(VueAxios, axios);

/**
 * Visjs
 */
Vue.component('network', Network);

/**
 * app
 * @type {HTMLElement}
 */
let app = document.getElementById('app');
new Vue({
  vuetify,
  store,
  render: h =>
    h(Inertia, {
      props: {
        initialPage: JSON.parse(app.dataset.page),
        resolveComponent: name => {
          return import(`@/Pages/${name}`).then(module => module.default);
        },
      },
    }),
}).$mount(app);
